module.exports = __webpack_public_path__ + "img/切片-46.d97b2945.jpg";